import React, { useMemo } from 'react';
import { useInstanceCallback } from '@leverege/ui-hooks';
import { rdvm } from "../Util.js";
import DataViewerCardModel from "./DataViewerCardModel.js";
/**
 * This CardView component will render the data represented by the DataViwerModel. The
 * dataViewer will used to find the actual DataViewer to render.
 * 
 * @param {Object} props Props
 * @returns 
 */
import { jsx as _jsx } from "react/jsx-runtime";
export default function DataViewerCardView(props) {
  const {
    value,
    sharedProps
  } = props;
  const dv = value?.dataViewer;
  const height = DataViewerCardModel.getHeight(value);
  const cardHeightAuto = height === '' || height === 'auto';
  const dvr = rdvm(dv, sharedProps, {
    inCard: true,
    cardHeightAuto,
    dataViewerCardModel: value,
    settingsData: 'setDataViewerSettings',
    onSettingsChange: useInstanceCallback(onSettingsChange, props)
  });
  const minHeight = DataViewerCardModel.getMinHeight(value);
  const maxHeight = DataViewerCardModel.getMaxHeight(value);
  const style = useMemo(() => {
    return {
      position: 'relative',
      width: '100%',
      height,
      minHeight,
      maxHeight
    };
  }, [height, minHeight, maxHeight]);
  return /*#__PURE__*/_jsx("div", {
    style: style,
    children: dvr
  });
}
function onSettingsChange(props, evt) {
  const {
    value,
    onChange,
    eventData
  } = props;
  const nModel = DataViewerCardModel[evt.data](value, evt.value);
  const nEvt = {
    value: nModel,
    data: eventData
  };
  onChange(nEvt);
}